import { FormattedMessage } from "react-intl";
import CustomCheckbox from "../../../../components/Common/CustomCheckbox/CustomCheckbox";
import { tableColumnTypes } from "../../../tableColumnTypes";
import { admin } from "../admin";

export const rolesAndPermission = {
  label: <FormattedMessage id="ROLES_PERMISSIONS" />,
  path: (tenantName) => `/${tenantName}/admin/rolesAndPermissions`,
  navLinks: (navigate, tenantName) => [
    {
      key: 1,
      label: "Admin Features",
      path: `${admin.path(tenantName)}`,
      onClick: () => navigate(`${admin.path(tenantName)}`),
    },
    {
      key: 2,
      label: rolesAndPermission.label,
      path: `${rolesAndPermission.path(tenantName)}`,
      onClick: () => navigate(`${rolesAndPermission.path(tenantName)}`),
    },
  ],
  columns: (col, onChange) => {
    return col?.map((item, index) => {
      return {
        ID: index + 2,
        name: item?.RoleName,
        fieldName: item?.RoleName,
        value: (row) => {
          return (
            <div>
              <CustomCheckbox
                checked={row?.lstRoles?.[index]?.IsMenuselected ? true : false}
                disabled={
                  row?.lstRoles?.[index]?.IsDefault ||
                  row?.PermissionKey === "Manage_Roles"
                    ? true
                    : false
                }
                onChange={() =>
                  onChange(
                    row?.lstRoles?.[index]?.RoleID,
                    row?.PermissionId,
                    row?.lstRoles?.[index]?.IsMenuselected
                  )
                }
              />
            </div>
          );
        },
        sort: false,
        type: tableColumnTypes.STRING,
      };
    });
  },
};
